
import TransitionRouterView from "@/components/TransitionRouterView.vue";
import SidebarMap from "@/components/ui/SidebarMap.vue";
import Nav from "@/components/ui/Nav.vue";

export default {
  name: "LayoutMap",
  components: {
    TransitionRouterView,
    SidebarMap,
    Nav
  },
  setup() {
    return {};
  }
};
